import { useState, useEffect } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { REACT_SELECT_STYLES } from "configurations/Constants";
import {
  LABEL_SELECT_CHEMICAL,
  LABEL_SELECT_TYPE,
} from "configurations/MessageConstants";
import Select from "react-select";
import { useSelector } from "react-redux";

const RecipeFilter = ({
  show,
  handleClose,
  selectedChemicals,
  selectedTypes,
  onApplyFilters,
  onResetFilters,
}) => {
  const [filterSelectedChemicals, setFilterSelectedChemicals] = useState([]);
  const [filterSelectedTypes, setFilterSelectedTypes] = useState([]);
  const { chemicals, recipeTypes } = useSelector((state) => state.recipe);

  const CHEMICAL_OPTIONS = chemicals.map((chemical) => ({
    value: chemical.name,
    label: chemical.name,
  }));

  const CHEMICAL_TYPE_OPTIONS = recipeTypes.map((recipeType) => ({
    value: recipeType.type,
    label: recipeType.type,
  }));

  useEffect(() => {
    if (show) {
      setFilterSelectedChemicals(selectedChemicals);
      setFilterSelectedTypes(selectedTypes);
    }
  }, [show, selectedChemicals, selectedTypes]);

  const handleClear = () => {
    setFilterSelectedChemicals([]);
    setFilterSelectedTypes([]);
  };

  const handleApply = () => {
    onApplyFilters({
      selectedChemicals: filterSelectedChemicals,
      selectedTypes: filterSelectedTypes,
    });
    handleClose();
  };

  const handleReset = () => {
    if (!onResetFilters()) return;
    handleClear();
    handleClose();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      aria-labelledby="recipes-filter"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title
          id="recipes-filter"
          className="w-100 d-flex align-items-center justify-content-between"
        >
          <span>Recipes Filter</span>
          <Button
            variant="link"
            onClick={handleReset}
            className="filter-reset-button"
            aria-label="Reset Filters"
          >
            <span className="filter-reset-button-text">Reset</span>
            <i className="fa fa-refresh"></i>
          </Button>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-3">
          <Form.Label>Chemical Name</Form.Label>
          <Select
            isMulti
            value={filterSelectedChemicals}
            onChange={setFilterSelectedChemicals}
            options={CHEMICAL_OPTIONS}
            placeholder={LABEL_SELECT_CHEMICAL}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Chemical"
          />
        </Form.Group>
        <Form.Group className="mb-4">
          <Form.Label>Type</Form.Label>
          <Select
            isMulti
            value={filterSelectedTypes}
            onChange={setFilterSelectedTypes}
            options={CHEMICAL_TYPE_OPTIONS}
            placeholder={LABEL_SELECT_TYPE}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Type"
          />
        </Form.Group>
        <div className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default RecipeFilter;
